/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import { throttle } from 'throttle-debounce';
import { publish } from '@wh/message-bus';
import Search from '@wh/svg-icons/Search';
import './search.scss';

export function SearchButton({ breakpoints, isAlwaysVisible, messageBusTopic }) {
  const [isVisible, setVisible] = useState(!!isAlwaysVisible);

  const handleSearchClick = useCallback(() => {
    publish(messageBusTopic);
  }, [messageBusTopic]);

  if (!isAlwaysVisible) {
    const updateVisibility = throttle(100, () => {
      if (window.innerWidth > breakpoints[breakpoints.length - 1].width) {
        setVisible(true);
        return;
      }
      for (let index = 0; index < breakpoints.length; index++) {
        if (window.innerWidth < breakpoints[index].width) {
          setVisible(!!breakpoints[index].isVisible);
          break;
        }
      }
    });

    useEffect(() => {
      updateVisibility();
      window.addEventListener('resize', updateVisibility);
      return () => {
        window.removeEventListener('resize', updateVisibility);
      };
    }, []);
  }

  return (
    <button className={`sb-header-search ${isVisible ? '' : 'sb-header-search--hidden'}`} onClick={handleSearchClick}>
      <Search />
    </button>
  );
}

const renderFunction = ({ data }) => {
  return (
    <SearchButton
      breakpoints={data.breakpoints}
      isAlwaysVisible={data.isAlwaysVisible}
      messageBusTopic={data.messageBusTopic}
    />
  );
};

const buildRenderer = () => ({
  type: 'searchRenderer',
  render: renderFunction,
  schema: {},
});

const SearchRenderer = buildRenderer();

export default SearchRenderer;
